<template>
    <div class="context common_add_view">
        <div class="header">
            <div class="search">
                <el-page-header @back="goBack" :content="viewTitle">
                </el-page-header>
            </div>
        </div>

        <div class="main_box">
            <el-form :model="form"
                     ref="ruleForm"
                     label-width="120px"
                     :rules="rules">
                <el-form-item label="微信扫码:">
                    <div class="qrcode" style="height: 200px">
                        <vue-qr :logoSrc="imageUrl"
                                :text="wx_qrcode"
                                v-if="wx_qrcode"
                                :size="200"></vue-qr>
                    </div>
                    <span style="color: #909399">注：请微信扫码选择预约直播或者直播回放</span>
                </el-form-item>
                <el-form-item label="noticeId:">
                    <span>{{form.noticeId}}</span>
                </el-form-item>
                <el-form-item label="开始时间:" prop="start_time">
                    <el-date-picker
                            v-model="form.start_time"
                            type="datetime"
                            clearable
                            class="width_220"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间:">
                    <el-date-picker
                            v-model="form.end_time"
                            type="datetime"
                            clearable
                            class="width_220"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="直播封面:" prop="cover">
                    <div style="display: flex;">
                        <ImgCutter v-on:cutDown="fileChange"
                                   :size-change="false"
                                   :moveAble="true"
                                   :tool="false"
                                   style="width: 110px">
                            <el-button slot="open">选择封面图片</el-button>
                        </ImgCutter>
                        <el-image
                                style="width: 150px;
                                 height: 150px;
                                  margin-left: 50px;"
                                :src="form.cover"
                                v-if="form.cover"
                                fit="contain">
                            <div slot="placeholder" class="image-slot">
                                暂无封面图片
                            </div>
                        </el-image>
                    </div>
                </el-form-item>
                <el-form-item label="直播标题:" prop="title">
                    <el-input v-model="form.title"
                              class="width_400"
                              maxlength="50"
                              placeholder="请输入直播标题"></el-input>
                </el-form-item>
                <el-form-item label="讲师:" prop="lecturer">
                    <el-input v-model="form.lecturer"
                              class="width_220"
                              maxlength="20"
                              placeholder="请输入讲师名称"></el-input>
                </el-form-item>
                <el-form-item label="医院:" prop="hospital_name">
                    <el-input v-model="form.hospital_name"
                              class="width_220"
                              maxlength="20"
                              placeholder="请输入医院"></el-input>
                </el-form-item>
                <el-form-item label="科室:" prop="department">
                    <el-input v-model="form.department"
                              class="width_220"
                              maxlength="20"
                              placeholder="请输入科室"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {clone} from "@/global/utils";
    import ImgCutter from 'vue-img-cutter'
    import vueQr from 'vue-qr'

    export default {
        name: "addView",
        components: {ImgCutter, vueQr},
        data() {
            const checkCover = (rule, value, callback) => {
                if(!value) {
                    callback(new Error('请选择封面'))
                } else {
                    callback()
                }
            };
            return {
                viewTitle: '添加直播',
                form: {
                    noticeId: '',
                    start_time: '',
                    end_time: '',
                    cover: '', // 封面
                    title: '', // 标题
                    lecturer: '', //  讲师
                    hospital_name: '', // 医院
                    department: '', // 科室
                },
                rules: {
                    title: [{required: true, message: '请输入直播标题！', trigger: 'blur'}],
                    start_time: [{required: true, message: '请选择开始时间！', trigger: 'blur'}],
                    cover: [{validator: checkCover, trigger: 'blur'}],
                    lecturer: [{required: true, message: '请输入讲师名称！', trigger: 'blur'}],
                    hospital_name: [{required: true, message: '请输入医院！', trigger: 'blur'}],
                    department: [{required: true, message: '请输入科室！', trigger: 'blur'}],
                },

                imageUrl: '',
                wx_qrcode: '',
                liveInter: null
            }
        },
        computed: {
            ...mapState('manageData', [
                'live_data'
            ]),
        },
        mounted() {
            if (this.live_data) {
                this.viewTitle = '修改直播信息';
                this.form = clone(this.live_data);
            } else {
                this.viewTitle = '添加直播';
                this.form = {
                    noticeId: '',
                    start_time: '',
                    end_time: '',
                    cover: '', // 封面
                    title: '', // 标题
                    lecturer: '', //  讲师
                    hospital_name: '', // 医院
                    department: '', // 科室
                }
            }

            this.getUuid()
        },
        beforeDestroy() {
            clearInterval(this.liveInter)
        },
        methods: {
            getUuid() {
                /**
                 * 生成唯一标识码uuid
                 */
                let d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += performance.now()
                }
                let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
                    /[xy]/g,
                    function (c) {
                        let r = (d + Math.random() * 16) % 16 | 0; // d是随机种子
                        d = Math.floor(d / 16);
                        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
                    }
                );
                let wx_path = 'https://tumor.lightinai.com:1043/live/select';
                this.wx_qrcode = `${wx_path}?uuid=${uuid}`;
                this.uuid = uuid;
                this.setInter()
            },
            setInter() {
                this.liveInter = setInterval(() => {
                    this.getLiveData()
                }, 1000 * 5)
            },
            getLiveData() {
                let params = {
                    uuid: this.uuid
                };
                this.httpGet('/live/get/live_info', params).then(res => {
                    if (res.data && res.data.uuid === this.uuid) {
                        this.form.noticeId = res.data.noticeId || '';
                        this.form.start_time = res.data.start_time || '';
                        this.form.title = res.data.title || '';
                        // 获取一次数据后刷新二维码，避免重复赋值
                        clearInterval(this.liveInter);
                        this.getUuid()
                    }
                })
            },

            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            fileChange(file) {
                this.form.cover = file.dataURL;
                // this.form.cover_file_id = file.dataURL;
                this.$forceUpdate()
            },

            submit() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };

                        if (this.viewTitle === '添加直播') {
                            this.httpPost('/live/create', params).then(res => {
                                this.$message.success('添加直播成功！');
                                this.goBack()
                            })
                        } else if (this.viewTitle === '修改直播信息') {
                            this.httpPost(`/live/${this.form.live_id}`,
                                params).then(res => {
                                this.$message.success('修改直播信息成功！');
                                this.goBack()
                            })
                        }

                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>